import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    data: {},
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    data(state) {
      return state.data;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertData(state, data) {
      state.data = data;
    },
    saveError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }, payload) {
      try {
        const res = await apiClient.proStatisticsASchema();
        let schema = res.data;
        let yearsXaxisCat = payload;
        schema.chartOptionsLineYear.xaxis.categories = yearsXaxisCat;

        // let yearActual = new Date().getFullYear();
        // let itemsYear = [];
        // for (let i = 0; i < 20; i++) {
        //   itemsYear[i] = yearActual - i;
        // };
        // schema.statsFormDate.formDateYear.items = itemsYear;

        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadData({ commit, dispatch }, payload) {
      try {
        let modelForm = {};
        if (payload === undefined) {
          const today = new Date();
          let formDateYear = today.getFullYear();
          let formDateMonth = today.getMonth() + 1;
          let modelStatsDate = { formDateYear, formDateMonth };
          modelForm.modelStatsDate = modelStatsDate;
        } else {
          let modelStatsDate = payload.modelForm.modelStatsDate;
          if (modelStatsDate === undefined) {
            const today = new Date();
            let formDateYear = today.getFullYear();
            let formDateMonth = today.getMonth() + 1;
            let modelStatsDate = { formDateYear, formDateMonth };
            modelForm.modelStatsDate = modelStatsDate;
          } else {
            modelForm = payload.modelForm;
          }
        }

        let model = {};
        model.instProfesId = getInstProfesId();
        model.modelForm = modelForm;

        const res2 = await apiClient.modelProStatisticsA(model);
        let data = res2.data.data;
        let dailyTotalData = data.lineDaily[0].data;

        let dailyXaxisCat = [];
        for (let i = 0; i < Object.keys(dailyTotalData).length; i++) {
          dailyXaxisCat[i] = `${1 + i}`;
        }
        data.dailyXaxisCat = dailyXaxisCat;

        let arrUbiTotal = Array.isArray(data.statUbi) ? data.statUbi : [];
        let arrUbiDepTot = [];
        for (let n = 0; n < arrUbiTotal.length; n++) {
          if (arrUbiDepTot.length === 0) {
            arrUbiDepTot.push(arrUbiTotal[n]);
          } else {
            for (let i = 0; i < arrUbiDepTot.length; i++) {
              let a = arrUbiTotal[n].ubigeo.substring(0, 2);
              let b = arrUbiDepTot[i].ubigeo.substring(0, 2);
              if (a === b) {
                arrUbiDepTot[i].femalePat = arrUbiDepTot[i].femalePat + arrUbiTotal[n].femalePat;
                arrUbiDepTot[i].malePat = arrUbiDepTot[i].malePat + arrUbiTotal[n].malePat;
                arrUbiDepTot[i].intersexualPat =
                  arrUbiDepTot[i].intersexualPat + arrUbiTotal[n].intersexualPat;
                arrUbiDepTot[i].totalPat = arrUbiDepTot[i].totalPat + arrUbiTotal[n].totalPat;
                break;
              }
              if (i === arrUbiDepTot.length - 1) {
                arrUbiDepTot.push(arrUbiTotal[n]);
                break;
              }
            }
          }
        }

        for (let i = 0; i < arrUbiDepTot.length; i++) {
          let deparmentUbi = arrUbiDepTot[i].ubigeo.substring(0, 2);
          arrUbiDepTot[i].ubigeo = `${deparmentUbi}`;
          let nameUbiPre = arrUbiDepTot[i].name;
          let nameUbiNum = nameUbiPre.indexOf('-') - 1;
          arrUbiDepTot[i].name = nameUbiPre.substring(0, nameUbiNum);
        }
        data.statUbi = arrUbiDepTot;

        payload = data.yearsXaxisCat;
        dispatch('loadSchema', payload);
        commit('insertData', data);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
  },
};
